module.exports = __webpack_public_path__ + "img/debs-alternate.221e7fe9.jpg";